import { usePrevious, useUpdated } from "@client/lib/hooks";

export type MapProps = {
  productId: string | null;
  productVariantId: string | null;
};

export type ActionProps = {
  setVariantId: (id: string | null) => void;
};

export default (props: ActionProps & MapProps) => {
  const previousProductId = usePrevious(props.productId);
  const previousProductVariantId = usePrevious(props.productVariantId);

  useUpdated(() => {
    if (previousProductId !== props.productId) {
      props.setVariantId(null);
    }
  }, [props.setVariantId, props.productId, previousProductId]);

  useUpdated(() => {
    if (previousProductVariantId !== props.productVariantId) {
      props.setVariantId(props.productVariantId);
    }
  }, [props.setVariantId, props.productVariantId, previousProductVariantId]);

  return null;
};
